import { SvgIcon } from '@mui/material';

const Lock = () => (
  <SvgIcon
    viewBox="0 0 19 24"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 19, height: 24, fill: 'none' }}
    data-testid="lockIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.53905 6.87513C2.53905 3.36445 5.65856 0.717285 9.24633 0.717285C12.8341 0.717285 15.9536 3.36445 15.9536 6.87513V9.38983H13.6122V6.87513C13.6122 4.88096 11.7762 3.05874 9.24633 3.05874C6.71642 3.05874 4.8805 4.88096 4.8805 6.87513V9.38983H2.53905V6.87513Z"
      fill="#4D5160"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.49761 10.5022V20.8562H15.9951V10.5022H2.49761ZM0.272949 10.4887C0.272949 9.26748 1.26293 8.2775 2.48414 8.2775H16.0085C17.2297 8.2775 18.2197 9.26748 18.2197 10.4887V20.8697C18.2197 22.0909 17.2297 23.0809 16.0085 23.0809H2.48414C1.26293 23.0809 0.272949 22.0909 0.272949 20.8697V10.4887Z"
      fill="#4D5160"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.1031 15.6766C4.1031 15.0623 4.60111 14.5642 5.21543 14.5642H5.83882C6.45315 14.5642 6.95115 15.0623 6.95115 15.6766C6.95115 16.2909 6.45315 16.7889 5.83882 16.7889H5.21543C4.60111 16.7889 4.1031 16.2909 4.1031 15.6766Z"
      fill="#4D5160"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.82232 15.6766C7.82232 15.0623 8.32032 14.5642 8.93464 14.5642H9.55803C10.1724 14.5642 10.6704 15.0623 10.6704 15.6766C10.6704 16.2909 10.1724 16.7889 9.55803 16.7889H8.93464C8.32032 16.7889 7.82232 16.2909 7.82232 15.6766Z"
      fill="#4D5160"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5362 15.6766C11.5362 15.0623 12.0342 14.5642 12.6486 14.5642H13.272C13.8863 14.5642 14.3843 15.0623 14.3843 15.6766C14.3843 16.2909 13.8863 16.7889 13.272 16.7889H12.6486C12.0342 16.7889 11.5362 16.2909 11.5362 15.6766Z"
      fill="#4D5160"
    />
  </SvgIcon>
);

export default Lock;
